import AppleLogin from "react-apple-login";
import { NavLink } from "hooks/useCustomNavigation";
import { SignUpForm } from "components/UI/organisms";
import {
  GiftNotification,
  ReferralSignupSection
} from "components/UI/molecules";
import { INTERNAL_PATHS } from "routes/paths";
import { useSignupPageParams } from "./utils/useSignupPageParams";
import "./index.scss";

export const SignUp = () => {
  const { referralParams, giftedParams, isReady } = useSignupPageParams();

  return (
    <div className="sign-up-page-container">
      {referralParams.isReferralPage && (
        <ReferralSignupSection code={referralParams.referralCode} />
      )}
      <div className="sign-up">
        <h1 className="title">Sign Up with GCX</h1>
        {giftedParams.isGifted ? (
          <GiftNotification gifter={giftedParams.gifter} />
        ) : (
          <p className="login">
            Already a GCX member?{" "}
            <NavLink
              to={INTERNAL_PATHS.USER_LOG_IN}
              className="login__hyperlink"
            >
              <strong>Log In</strong>
            </NavLink>
          </p>
        )}

        {isReady && (
          <SignUpForm
            defaultValues={{
              ...(referralParams.isReferralPage && {
                referralCode: referralParams.referralCode
              }),
              ...(giftedParams.isGifted && {
                email: giftedParams.email
              })
            }}
          />
        )}

        <AppleLogin
          clientId="com.raisestaging.gcx"
          redirectURI="https://gcx.raisestaging.com/user/auth/apple/callback"
          responseType="code"
          responseMode="query"
          // scope="email name"
          // state="52b052e62d5dc664b5534db1d9d27555e75f130f509f659a"
          callback={(response) => console.log(response)}
        />
      </div>
    </div>
  );
};
